<template>
  <a-cascader @change="changeXzc" v-model="defaultValue" :disabled="disableds" :options="options" :placeholder="placeholder" />
</template>
<script>
import { getAction } from '@/api/manage'

export default {
  name: 'OrgSelect',
  props: {
    category: String,
    placeholder: String,
    value:String,
    csh:Boolean,
    pcd:String,
    jectValue:String,
    disabled:{
      type:Boolean,
      default: false
    },
    getPopupContainer:{
      type: Function,
      default: (node) => node.parentNode
    }
  },

  data() {
    return {
      options: [],
      defaultValue:[],
      disableds:false
    };
  },
  created(){
    this.$nextTick(() => {
        // this.initAreaData(this.jectValue,this.pcd);
    })
  },
  methods: {
    changeXzc(value) {
      var val='';
      if(value.length>0){
        val=value[value.length-1];
      }
      this.$emit('change', val);
    },
    initAreaData(record,pCode){
      let taht = this;
      getAction('/sys/category/loadTreeRoot?async=false&pcode='+pCode,{}).then((res)=>{
        let orgList = res.result;
        let newArr = [];
        for(var i=0;i<orgList.length;i++){
            if(i!=1){
                newArr.push(orgList[i]);
            }
        }
        newArr = this.getchildren(newArr);
        taht.options = newArr;
        taht.defaultValue =  []; 
        
        if(record==""||record==null||typeof record=='undefined'){
          taht.defaultValue =  []; 
        }else{
          for(let i=0;i<(record.length-pCode.length)/3;i++){
            taht.defaultValue.push(record.substr(0,(i+1)*3+pCode.length));
          }
        }
        taht.disableds = taht.disabled;
      })
    },
    getchildren(orgList){
      for(var i = 0;i<orgList.length;i++){
        orgList[i].value = orgList[i].code;
        orgList[i].label = orgList[i].title;
        if(orgList[i].children != null){
          this.getchildren(orgList[i].children);
        }else{
          orgList[i].children = undefined;
        }
      }
      return orgList;
    }
  },
};
</script>